<template>
    <el-container id="user">
        <el-header style="height:50px;">
            <div class="main-container">
                <el-row>
                    <el-col :span="8">
                        <div class="top-col f-20">
                            <!--<img src="../../../assets/gy_logo.png" width="50px" style="float: left">-->
                            欢迎使用患者门户平台
                        </div>
                    </el-col>
                    <el-col :span="8"><div class="top-col">&nbsp;</div></el-col>
                    <el-col :span="8">
                        <div class="top-col f-r">
                            <span class="el-dropdown-link" style="font-size:14px;color:#606266">您好 {{name}}</span>
                            <a target="_blank" :href="jkdaPath">
                                <el-button type="text" style="margin-left:30px;">
                                    <label style="width:20px;height:20px;position:relative;"><img src="./健康档案icon.png" style="position:absolute;left:-15px;"></label>
                                    健康档案</el-button>
                            </a>

                            <!--<el-dropdown @command="editUserInfo">-->
                                <!--<span class="el-dropdown-link">-->
                                   <!--您好：{{name}}<i class="el-icon-arrow-down el-icon&#45;&#45;right"></i>-->
                                <!--</span>-->
                                <!--<el-dropdown-menu slot="dropdown">-->
                                    <!--<el-dropdown-item command="1">编辑信息</el-dropdown-item>-->
                                <!--</el-dropdown-menu>-->
                            <!--</el-dropdown>-->
                            <el-button type="text" @click="logout" style="margin-left:10px;">退出</el-button>
                        </div>
                    </el-col>
                </el-row>
            </div>
        </el-header>
        <el-main >
            <div class="main-banner">
                <div class="main-container">
                    <el-row>
                        <el-col :span="7"><div>&nbsp;</div></el-col>
                        <el-col :span="10">
                            <div class="logo">
                                <i class="fa fa-stethoscope" aria-hidden="true"></i>
                            </div>
                            <h1>广元市第四人民医院</h1>
                            <h2>CARE FOR YOU</h2>
                        </el-col>
                        <el-col :span="7">
                            <div class="phone">
                                <i class="fa fa-phone" aria-hidden="true"></i>
                                <span>+86 0839-3451422</span>
                            </div>
                        </el-col>
                    </el-row>
                </div>
            </div>
        </el-main>
        <edit ref="editDialog"></edit>
        <QrCode></QrCode>
    </el-container>
</template>

<script>
    import QrCode from './qr-code.vue'
    import Edit from './edit.vue'
    export default {
        name: 'Header',
        components:{Edit,QrCode},
        data () {
            return {
                name:'',
                jkdaPath:process.env.VUE_APP_JKDA_PATH
            }
        },
        mounted(){
            this.checkLogin()
        },
        methods:{
            checkLogin(){
                let info = this.$cookies.get('LOGIN_INFO')
                if(!info){
                    this.logout()
                }
                this.name = info && info.xm ? info.xm : ''
                this.jkdaPath += info && info.mdmId ? '&mid='+info.mdmId : '&mid='
            },
            editUserInfo(command){
                this.$refs.editDialog.showDialog(true);
            },
            logout(){
                this.$cookies.remove('LOGIN_INFO')
                this.$router.push({ name: 'login'})
            },
        }
    }
</script>

<style lang="scss">
    #user{
        font-family:微软雅黑,Microsoft YaHei;
    .el-header{
        padding:0px;
        position:fixed;
        width:100%;
        box-shadow:0 3px 3px hsla(0,0%,53%,.251);
        background: #fff;
        z-index:10;
    }
    .main-container{
        max-width:1280px;
        margin:0 auto;
        padding-left:20px;
        padding-right:20px;
    }

    .top-col{
        height:50px;
        line-height:50px;
    }
    .el-main{
        padding:0px;
        margin-top:50px;
    }
    .main-banner{
        width:100%;
        height:280px;
        background:url("../../../assets/image/55.jpg") no-repeat center 0px;
        background-size: cover;
    }
    }
</style>



// WEBPACK FOOTER //
// src/components/pc/components/Header.vue